import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import Ventures from "@/pages/public/Ventures";
import VentureDetail from "@/pages/public/VentureDetail";
import Services from "@/pages/public/Services";
import Consultation from "@/pages/public/Consultation";
import Partnerships from "@/pages/public/Partnerships";
import Acquisitions from "@/pages/public/Acquisitions";
import Insights from "@/pages/public/Insights";
import InsightDetail from "@/pages/public/InsightDetail";
import About from "@/pages/public/About";
import Contact from "@/pages/public/Contact";
import Legal from "@/pages/public/Legal";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";

import AdminLayout from "@/components/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import VenturesAdmin from "@/pages/admin/VenturesAdmin";
import Finance from "@/pages/admin/Finance";
import BusinessServices from "@/pages/admin/BusinessServices";
import CRM from "@/pages/admin/CRM";
import Enquiries from "@/pages/admin/Enquiries";
import Tasks from "@/pages/admin/Tasks";
import Documents from "@/pages/admin/Documents";
import InsightsAdmin from "@/pages/admin/InsightsAdmin";
import Users from "@/pages/admin/Users";
import Security from "@/pages/admin/Security";
import Settings from "@/pages/admin/Settings";

function AppRoutes() {
  const location = useLocation();
  // Google OAuth returns to {origin}/admin#session_id=... — handle before anything else.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/ventures" element={<Ventures />} />
        <Route path="/ventures/:slug" element={<VentureDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/consultation" element={<Consultation />} />
        <Route path="/partnerships" element={<Partnerships />} />
        <Route path="/acquisitions" element={<Acquisitions />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<InsightDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/legal/:doc" element={<Legal />} />
      </Route>

      <Route path="/login" element={<Login />} />

      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="ventures" element={<VenturesAdmin />} />
        <Route path="finance" element={<Finance />} />
        <Route path="business-services" element={<BusinessServices />} />
        <Route path="crm" element={<CRM />} />
        <Route path="enquiries" element={<Enquiries />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="documents" element={<Documents />} />
        <Route path="insights" element={<InsightsAdmin />} />
        <Route path="security" element={<Security />} />
        <Route path="users" element={<Users />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteProvider>
          <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#1A1A1A", border: "1px solid rgba(184,156,101,0.3)", color: "#F9F8F6" } }} />
          <AppRoutes />
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
